function PurchasedStatus() {
  return (
    <div className="w-[84px] h-[22px] flex items-center justify-center rounded-[11px] bg-po_color3 font-OpenSansRegular font-[400] text-titleColor text-[10px]">
      PURCHASED
    </div>
  );
}

export default PurchasedStatus;
